import { IconInfoCircle, IconPencilQuestion, IconUserShield } from '@tabler/icons-react';

// ==============================|| ALL MENU ITEMS ||============================== //

const all_nav = [{
    id: 'basic-info',
    title: '고객서비스',
    type: 'group',
    children: [
        {
            id: 'service-info',
            title: '서비스 소개',
            type: 'item',
            icon: IconInfoCircle,
            url: '/service-info/'
        },
        {
            id: 'faq',
            title: '자주 묻는 질문',
            type: 'item',
            icon: IconPencilQuestion,
            url: '/faq/'
        },
        {
            id: 'privacy',
            title: '개인정보 처리방침',
            type: 'item',
            icon: IconUserShield,
            url: '/privacy/'
        }
    ]
}
];

export default all_nav;
